export const determinePropertyAddress = (propertyAddress?: string, title?: string): string => {
  if (propertyAddress) return propertyAddress;
  
  // Try to extract from title if it follows the pattern "Type - Address"
  if (title && title.includes(' - ')) {
    return title.split(' - ')[1];
  }
  
  // Use a clean fallback instead of autogenerated ID
  return "Contact for address details";
};

export const calculatePropertyValue = (
  propertyValue?: number, 
  remainingBalance?: number, 
  investmentToValue?: string
): number => {
  if (propertyValue) return propertyValue;
  
  if (remainingBalance && investmentToValue) {
    const ltv = parseInt(investmentToValue.replace(/[^\d]/g, '') || '75');
    return Math.round(remainingBalance / (ltv / 100));
  }
  
  return 0;
};